import * as React from 'react';
import { styled } from '@mui/material/styles';
import Badge from '@mui/material/Badge';
import Avatar from '@mui/material/Avatar';
import Stack from '@mui/material/Stack';

// Define the props type
interface EnmaeyaAvatarProps {
  status?: 'online' | 'offline';
}

// Styled badge based on status
const getStyledBadge = (status: 'online' | 'offline') =>
  styled(Badge)(({ theme }) => ({
    '& .MuiBadge-badge': {
      backgroundColor: status === 'offline' ? 'red' : '#44b700',
      color: status === 'offline' ? 'red' : '#44b700',
      boxShadow: `0 0 0 2px ${theme.palette.background.paper}`,
      '&::after': {
        position: 'absolute',
        top: -1,
        left: -1,
        width: '100%',
        height: '100%',
        borderRadius: '50%',
        animation: 'ripple 1.2s infinite ease-in-out',
        border: '1px solid currentColor',
        content: '""',
      },
    },
    '@keyframes ripple': {
      '0%': {
        transform: 'scale(.8)',
        opacity: 1,
      },
      '100%': {
        transform: 'scale(2.4)',
        opacity: 0,
      },
    },
  }));

// Main component
export default function EnmaeyaAvatar({ status = 'offline' }: EnmaeyaAvatarProps) {
  const StyledBadge = getStyledBadge(status);

  return (
    <Stack direction="row" spacing={2}>
      <StyledBadge
        overlap="circular"
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        variant="dot"
      >
        <Avatar alt="Remy Sharp" src="/logo_bot.png" />
      </StyledBadge>
    </Stack>
  );
}
